import Joi from "joi";
import { CustomField } from "../../../graphql/generated";

const customFieldSchema = Joi.object<CustomField>({
  key: Joi.string().required().label("Key"),
  value: Joi.any().required().label("Value").allow(null),
});

export default customFieldSchema;
